export default __webpack_public_path__ + "static/media/ac_pm.39984091.bmp";